import React from 'react';
import Header from "./Header";
import SensorValue from "./SensorValue";
import {withStyles} from "@material-ui/core/styles";
import Offline from "./Offline";
import HistoryChart from "./HistoryChart";
import PropTypes from "prop-types";
import Footer from "./Footer";

const styles = theme => ({
    root: {},
    sensorsContainer: {
        display: 'flex',
        flexFlow: 'row wrap',
        background: theme.palette.common.white,
        overflow: 'hidden'
    },
    sensor: {
        flex: '1 0 33.33%',
        boxSizing: 'border-box',
        borderRight: [[1, 'solid', theme.palette.divider]]
    },
    chartContainer: {
        padding: theme.spacing(2),
        height: 64,
        background: theme.palette.common.white,
    }
});

const sensors = [
    'iaq', 'temp', 'humi'
];

const Device = ({classes, realTime, serial, room, model, status, color, selected, ...props}) => {
    const online = realTime && realTime.status === 'online';

    return (
        <div className={classes.root}>
            <Header
                room={room}
                model={model}
                status={status}
                color={color}
            />

            {!online && (
                <Offline realTime={realTime} />
            )}

            {online && (
                <div className={classes.sensorsContainer}>
                    {sensors.map(sensor => (
                        <SensorValue
                            key={sensor}
                            className={classes.sensor}
                            sensorTypeName={sensor}
                            value={realTime[sensor]}
                        />
                    ))}
                </div>
            )}

            {online && (
                <div className={classes.chartContainer}>
                    <HistoryChart serial={serial} color={color}/>
                </div>
            )}

            <Footer color={color} selected={selected} />
        </div>
    );
};

Device.propTypes = {
    serial: PropTypes.string.isRequired
};

export default withStyles(styles)(Device);
